import React, { useContext, useMemo } from 'react'
import { CommentCardContext } from './CommentCardGroup/CommentCardGroup'
import { Menu, MenuButton, Portal } from '@chakra-ui/react'
import { MdMoreVert } from 'react-icons/md'
import PropTypes from 'prop-types'
import CustomMenuList from '../../ui/CustomMenuList/CustomMenuList'

const CommentOptions = ({ commentId }) => {
  const { onEdit, onDelete, commentCardRef } = useContext(CommentCardContext)

  const menuItems = useMemo(
    () => [
      {
        id: '1',
        label: 'Edit',
        action: () => {
          onEdit(commentId)
        },
      },
      {
        id: '2',
        label: 'Delete',
        action: () => {
          onDelete(commentId)
        },
      },
    ],
    [commentId, onEdit, onDelete],
  )

  return (
    <Menu>
      <MenuButton title="More">
        <MdMoreVert
          size={30}
          aria-label="more"
          variant="transparent"
          position="relative"
          mr={'-12px'}
          p={0}
        />
      </MenuButton>
      <Portal containerRef={commentCardRef}>
        <CustomMenuList items={menuItems} />
      </Portal>
    </Menu>
  )
}

CommentOptions.propTypes = {
  commentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default React.memo(props => <CommentOptions {...props} />)
